import { combineReducers } from 'redux';
import Course from './Course';
import Courses from './Courses';
import ProgramData from './ProgramData';
import Programs from './Programs';
import Grant from './Grant';
import Grants from './Grants';
import Jurisdiction from './Jurisdiction';
import Jurisdictions from './Jurisdictions';
import loader from './loader';
import login from './login';
import Alerts from './Alerts';
import NewUser from './NewUser';
import PersonData from './PersonData';
import Project from './Project';
import Projects from './Projects';
import PickLists from './PickLists';
import SearchResults from './SearchResults';
import Session from './Session';
import Sessions from './Sessions';
import StaticData from './StaticData';
import TrainingData from './TrainingData';
import Trainings from './Trainings';
import TrainingTypes from './TrainingTypes';
import TrainingType from './TrainingType';
import Users from './Users';

export default () =>
    combineReducers({
        Course,
        Courses,
        ProgramData,
        Programs,
        Grant,
        Grants,
        Jurisdiction,
        Jurisdictions,
        loader,
        login,
        Alerts,
        NewUser,
        PersonData,
        PickLists,
        Project,
        Projects,
        SearchResults,
        Session,
        Sessions,
        StaticData,
        TrainingData,
        Trainings,
        TrainingTypes,
        TrainingType,
        Users
});
 